import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DriverAssignLink } from '../../../core/utils/DriverAssignLink';

@Component({
  templateUrl: './assign-driver-to-transport-qrcode-modal.component.html',
})
export class AssignDriverToTransportQrcodeModalComponent implements OnInit {
  @Input({ required: true }) companyId: string;
  @Input({ required: true }) transportId: string;
  @Input() accessCode: string;
  @Input() submitter: string;
  qrCodeUrl: string;

  constructor(public readonly modal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.qrCodeUrl = this.createInviteUrl();
  }

  createInviteUrl(): string {
    return DriverAssignLink.transportUrl(window.location.origin, {
      companyId: this.companyId,
      transportId: this.transportId,
      accessCode: this.accessCode,
      submitter: this.submitter,
      ecmrAccessInfo: true
    });
  }

  copyInviteUrl() {
    navigator.clipboard.writeText(this.qrCodeUrl).catch(e => console.error(e));
  }
}
